import React, { createContext, useContext, useState } from "react";
import LoadingSpinnerOverlay from "../loading-spinner-overlay";

const LoadingContext = createContext();

const LoadingProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(false);
  const [message, setMessage] = useState(null);

  useState(
    () => {
      if (!loading) {
        setMessage(null);
        setProgress(false);
      }
    },
    [loading],
  );

  return (
    <LoadingContext.Provider value={{ loading, setLoading, progress, setProgress, message, setMessage }}>
      <LoadingSpinnerOverlay />
      {children}
    </LoadingContext.Provider>
  );
};

const useLoadingContext = () => {
  const context = useContext(LoadingContext);
  if (context === undefined) {
    throw new Error("useLoadingContext must be used within a LoadingProvider");
  }
  return context;
};

export { LoadingProvider, useLoadingContext };
